
import { defineComponent, computed } from "vue";
import Loader from "@/views/Components/Loader.vue";
import Modal from "../Components/Modal.vue";
import { useStore } from "../../stores";
import { ActionTypes } from "../../stores/action-types";
import router from "../../router";
import { RoomItem } from "@/types/room-item";

export default defineComponent({
  name: "RoomModal",

  data: () => ({
    progress: 0,
    roomName: '',
    roomPlayersCount: 0,
  }),

  setup() {
    const store = useStore();
    const room = computed(() => store.state.rooms[0]);
    return { room };
  },

  mounted() {
    const progressInterval = setInterval(() => {
      if (this.progress === 10) { // wait one second for the response from the server
        this.roomName = this.room.roomName;
        this.roomPlayersCount = this.room.players;
      }
      if (this.progress === 100) {
        clearInterval(progressInterval);
        this.joinRoom();
        return;
      }
      this.progress += 10;
    }, 200);
  },

  methods: {
    joinRoom() {
      const store = useStore();
      this.$emit('close');
      store.dispatch(ActionTypes.ENTER_ROOM, this.room.roomId);
      router.push({ path: '/game' });
    },
  },

  components: { Loader, Modal },
});
